export const mapUpsertCustomLayout = ({ entity, config, id }) => {
  const payload = {
    entity: entity,
    config: config,
    id: id,
  };

  return {
    customTableLayout: payload,
  };
};
